import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=70684642&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"
import style0 from "./Test.vue?vue&type=style&index=0&id=70684642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70684642",
  null
  
)

export default component.exports